export default __webpack_public_path__ + "static/media/matricula.d073c74b.jpg";